/**
 * Keyboard navigation and shortcuts
 */

export function initializeKeyboardNavigation() {
  // Enhanced navigation with keyboard support
  document.addEventListener('keydown', (e) => {
    // Alt + D for Dashboard
    if (e.altKey && e.key === 'd') {
      e.preventDefault();
      const dashboardLink = document.querySelector('a[href*="dashboard"]');
      if (dashboardLink) {
        window.location.href = dashboardLink.href;
      }
    }

    // Alt + U for Users (if admin)
    if (e.altKey && e.key === 'u') {
      e.preventDefault();
      const usersLink = document.querySelector('a[href*="users"]');
      if (usersLink) {
        window.location.href = usersLink.href;
      }
    }

    if (e.key === 'Escape') {
      const modals = document.querySelectorAll('.modal.show');
      modals.forEach((modal) => {
        if (modal.hasAttribute('data-uploading')) {
          return;
        }
        const bsModal = bootstrap.Modal.getInstance(modal);
        if (bsModal) {
          bsModal.hide();
        }
      });
    }
  });

  // Auto-focus first input on page load
  const firstInput = document.querySelector('input:not([type="hidden"]):not([readonly]):not([disabled])');
  if (firstInput && !firstInput.value) {
    firstInput.focus();
  }
}
